const terms = {
  ru: 'Временно недоступно',
  uz: 'Временно недоступно',
}

export default terms
